import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            故事分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            用不同的视角，感受妈妈们丰富的情感世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-50 rounded-lg hover:shadow-sm transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 font-heading text-base text-foreground-950 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {cat.description}
              </p>
              <span className="mt-3 text-xs text-foreground-400">
                {cat.count} 篇故事
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}